import React from 'react'

export default function Checkboxes() {
  return (
    <div>Checkboxes</div>
  )
}
